<div class="flex items-center justify-center gap-3 py-2 px-3 rounded-2xl bg-gray-200 ">
    <span>{{value ? "Enabled" : "Disabled"}}</span>
    <div class="[&>*]:border-2 text-[#00ff00]">
        <div class="bg-green-400 rounded-full w-[15px] h-[15px]" *ngIf="value"></div>
        <div class="bg-red-500 rounded-full w-[15px] h-[15px]" *ngIf="!value"></div>
    </div>
</div>
